"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformedEventDataToJSON = exports.TransformedEventDataFromJSONTyped = exports.TransformedEventDataFromJSON = void 0;
var runtime_1 = require("../runtime");
function TransformedEventDataFromJSON(json) {
    return TransformedEventDataFromJSONTyped(json, false);
}
exports.TransformedEventDataFromJSON = TransformedEventDataFromJSON;
function TransformedEventDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'gameId': json['gameId'],
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : json['data'],
        'eventTypeId': !(0, runtime_1.exists)(json, 'eventTypeId') ? undefined : json['eventTypeId'],
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}
exports.TransformedEventDataFromJSONTyped = TransformedEventDataFromJSONTyped;
function TransformedEventDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'gameId': value.gameId,
        'data': value.data,
        'eventTypeId': value.eventTypeId,
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}
exports.TransformedEventDataToJSON = TransformedEventDataToJSON;
